export const DEFAULT_TASK_TABLE_COLUMN_ORDER = [
    'task',
    'owner',
    'status',
    'timeline',
    'duration',
    'mode',
    'deadline',
    'priority',
    'workstream',
    'tag',
    'projectPhase',
    'lastUpdated',
    'addedOn',
];

export const TASK_TABLE_COLUMN_LABELS = {
    task: 'Task',
    owner: 'Owner',
    status: 'Status',
    timeline: 'Timeline',
    duration: 'Duration',
    mode: 'Mode',
    deadline: 'Deadline',
    priority: 'Priority',
    workstream: 'Workstream',
    tag: 'Tag',
    projectPhase: 'Project Phase',
    lastUpdated: 'Last Updated',
    addedOn: 'Added On',
};

const HIDDEN_COLUMNS_STORAGE_KEY = 'taskTableHiddenColumns';
const SHOW_ALL_COLUMNS_STORAGE_KEY = 'taskTableShowAllColumns';

/** Match TasksTable localStorage column-order normalization. */
export const normalizeTaskTableColumnOrder = savedOrder => {
    if (!Array.isArray(savedOrder) || savedOrder.length === 0) {
        return [...DEFAULT_TASK_TABLE_COLUMN_ORDER];
    }

    const cleaned = DEFAULT_TASK_TABLE_COLUMN_ORDER.filter(columnKey => savedOrder.includes(columnKey));
    const missing = DEFAULT_TASK_TABLE_COLUMN_ORDER.filter(columnKey => !cleaned.includes(columnKey));
    return [...cleaned, ...missing];
};

export const readTaskTableColumnOrder = () => {
    try {
        const saved = localStorage.getItem('taskTableColumnOrder');
        if (saved) {
            return normalizeTaskTableColumnOrder(JSON.parse(saved));
        }
    } catch (e) {}
    return [...DEFAULT_TASK_TABLE_COLUMN_ORDER];
};

export const readTaskTableColumnVisibility = () => {
    try {
        const showAllRaw = localStorage.getItem(SHOW_ALL_COLUMNS_STORAGE_KEY);
        const hiddenRaw = localStorage.getItem(HIDDEN_COLUMNS_STORAGE_KEY);
        const showAllColumns = showAllRaw == null ? true : showAllRaw === 'true';
        const hiddenColumns = hiddenRaw ? JSON.parse(hiddenRaw) : [];
        return {
            showAllColumns,
            hiddenColumns: Array.isArray(hiddenColumns) ? hiddenColumns : [],
        };
    } catch (e) {
        return { showAllColumns: true, hiddenColumns: [] };
    }
};

export const persistTaskTableColumnVisibility = ({ showAllColumns, hiddenColumns }) => {
    try {
        localStorage.setItem(SHOW_ALL_COLUMNS_STORAGE_KEY, String(showAllColumns));
        localStorage.setItem(HIDDEN_COLUMNS_STORAGE_KEY, JSON.stringify(hiddenColumns || []));
    } catch (e) {}
};

export const isTaskTableColumnVisible = (columnKey, { showAllColumns, hiddenColumns }) => {
    if (showAllColumns) return true;
    return !hiddenColumns.includes(columnKey);
};

/** Same visible-column sequence as TasksTable: columnOrder filtered by visibility. */
export const getTaskTableVisibleColumns = ({ columnOrder, showAllColumns, hiddenColumns, isColumnVisible }) => {
    const visibilityCheck =
        typeof isColumnVisible === 'function'
            ? isColumnVisible
            : columnKey => isTaskTableColumnVisible(columnKey, { showAllColumns, hiddenColumns });

    return normalizeTaskTableColumnOrder(columnOrder).filter(
        columnKey => visibilityCheck(columnKey) && TASK_TABLE_COLUMN_LABELS[columnKey],
    );
};
